import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} nearby. Noted.",
  "alert.toast.escalation": "{hazard} nearby. Now worse.",
  "alert.toast.inPath": "{hazard} headed your way. Of course.",
  "alert.toast.allClear": "Fine again near {place}.",
  "alert.toast.tap": "Details, if you're curious.",
  "alert.takeover.title": "{hazard}. This is the part where you move.",
  "alert.takeover.details": "The details",
  "alert.takeover.dismiss": "Noted",
  "now.status.allClear": "Nothing to report.",
  "now.status.stayAware": "Eyes open.",
  "now.status.sub.allClear": "Nothing within your radius. Enjoy it.",
  "now.activity.empty": "Nobody's reported anything. Suspicious.",
  "onboarding.promise.tagline": "Neighbors, warning neighbors. Revolutionary.",
  "onboarding.promise.continue": "Fine, let's go",
  "onboarding.home.browse": "Just looking",
  "you.voice.intro": "Pick how blunt you'd like this to be.",
};
